import React from 'react';
import { Button, DropDown } from "MWC";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        mode = calc.props.type;

    let selectOptions = [];

    for (let option in model.getMetalAlloy()) {
        selectOptions.push(
            <option key={option} value={option}>
                {option === '900750' ? calc.l10n(`CREDIT_PAWNSHOP_DENTAL_SCRAP`) : option}
            </option>,
        );
    }

    const error = model.getExceededLimitation() ?
        <p className="error-hint">{calc.l10n('CREDIT_PAWNSHOP_ERROR')} {`${model.getLimit()}`} {calc.l10n('CALCULATOR_GRAM')}</p> : '';

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <p className="calc-block-title">{calc.l10n('CALCULATOR_PAWNSHOP_SCHEME')}</p>
                <div className="mode-switchers" style={{ marginBottom: "28px" }}>
                    <Button name="gold"
                        className={`${mode === 'gold' ? "selected" : ""} btn-transparent`}
                        onClick={calc.toggleMode}>
                        {calc.l10n("CREDIT_PAWNSHOP_CALCULATOR_TAB_1")}
                    </Button>
                    <Button name="silver"
                        className={`${mode === 'silver' ? "selected" : ""} btn-transparent`}
                        onClick={calc.toggleMode}>
                        {calc.l10n("CREDIT_PAWNSHOP_CALCULATOR_TAB_2")}
                    </Button>
                </div>

                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditTerm()} {calc.l10n('CALCULATOR_DAY') } 
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="loanTerm"
                                className="calculator-term-slider"
                                onChange={calc.handleChange}
                                value={model.getCurrentTerm()}
                                min="0" max={model.getTerms().length - 1} step="1" />
                        </div>
                    </div>
                </div>

                <div className="pawnshop-controllers">
                    <div className="controller-block">
                        <div className="calc-block-title">
                            {calc.l10n('CALCULATOR_METAL_ALLOY')}
                        </div>

                        <DropDown className="metal-alloy-controller"
                            name="alloy"
                            value={model.getCurrentMetalAlloy()}
                            onChange={calc.handleChange}
                            collection={selectOptions}
                        />
                    </div>

                    <div className="controller-block">
                        <div className="calc-block-title">
                            {calc.l10n('CALCULATOR_METAL_WEIGHT')}
                        </div>
                        <input
                            className={`calc-manual-input ${model.getExceededLimitation() ? 'error' : ''}`}
                            name="weight"
                            type="text"
                            value={model.getWeight()}
                            onChange={calc.handleChange}
                            maxLength={model.getType() === "gold" ? 6 : 7}
                            placeholder="0"
                            autoComplete="off" />

                        {error}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
